import React, { Component } from 'react'
import { withRouter } from 'react-router'
import { connect } from 'react-redux'
import cx from 'classnames'

import './featured-partner.scss'

class FeaturedPartner extends Component {

    state = {
        opacity: 1,
        featuredPartners: []
    }

    static getDerivedStateFromProps (nextProps, prevState) {
        if (nextProps.featuredPartners && prevState.featuredPartners.length === 0) {
            return { featuredPartners: nextProps.featuredPartners }
        }
        return {}
    }

    onScroll = () => {
        const { pageYOffset } = window
        const threshold = 100
        if (pageYOffset >= threshold) {
            this.setState({ opacity: 1 - (pageYOffset - threshold) * 0.0075 })
        } else if (pageYOffset === 0) {
            this.setState({ opacity: 1 })
        }
        
    }

    componentDidMount () {
        window.addEventListener('scroll', this.onScroll, false)
    }

    componentWillUnmount () {
        window.removeEventListener('scroll', this.onScroll, false)
    }

    onClick = e => {
        // const { featuredPartners } = this.state
        const featuredPartner = this.state.featuredPartners[this.props.activeVideoIdx]
        const { name } = featuredPartner
        const { city } = featuredPartner.info
        // scrollTo(400, 0, 'easeOutQuad')

        this.props.history.push(`/${name}/${city}/1/exact`)
    }

    render () {

        const { 
            featuredPartners
        } = this.state

        const resBreakpoint = 1420
        const style = window.innerWidth > resBreakpoint ? { opacity: this.state.opacity } : {}

        const className = cx(
            'featured-partner'
        )

        return (
            <div 
                className={className}
                style={style}
                onClick={this.onClick}>
                {(featuredPartners ? featuredPartners : []).map((partner, i) => {
                    const { imageUrl, name: title } = partner
                    const className = cx({ 'active': this.props.activeVideoIdx === i })
                    return (
                        <h4 className={className} key={title}>
                            <img onLoad={this.onImageLoad} src={imageUrl} alt={title} />
                            <span>Currently showcasing</span>&nbsp;
                            <span>{title}</span>
                        </h4>
                    )
                })}
            </div>
        )
    }
}

export default connect(state => {
    return {
        activeVideoIdx: state.uiReducer.activeVideoIdx
    }
})(withRouter(FeaturedPartner))


// WEBPACK FOOTER //
// ./src/components/hero-unit/featured-partner/index.jsx